/* eslint-disable no-unused-vars */

import { useContext, useEffect, useRef, useState } from "react";
import { AnimationMixer, LoopOnce } from "three";
import { SettingsContext } from '../context'



function AnimationSettings(
  { setAnimationSpeed, setAnimationType, elements }
) {


  const { setAnimations } = useContext(SettingsContext);
  var a = document.getElementById("asdasd");


  useEffect(() => {

    const modelViewer = document.getElementById("modelViewer");
    modelViewer.addEventListener("init-model-load", loadAnimations.bind(this));

  }, [])


  const loadAnimations = async () => {

    const modelViewer = document.getElementById("modelViewer");
    const scene = modelViewer?.scene();

    if (!scene.animations)
      return;

    let newAnimations = [];
    let animationActions = [];
    let animationMixer = new AnimationMixer(scene);


    scene.animations.forEach(clip => {

      let animInfo = { "id": clip.uuid, "name": clip.name, "duration": clip.duration }
      newAnimations.push(animInfo);

      const action = animationMixer.clipAction(clip);
      animationActions.push(action);

    });

    setAnimations(newAnimations);
  }


  const handleAnimationSpeed = (event) => {

    let element = event.currentTarget;
    let classList = element.classList;
    let speed = element.dataset.value;
    setAnimationSpeed(speed);

    let parentElement = element.parentElement;
    removeActiveChildren(parentElement);

    classList.add("active");
    updateAnimationElementSpeed(speed);
  }

  const handleAnimationType = (event) => {

    let element = event.currentTarget;
    let type = element.dataset.value;
    let classList = element.classList;
    setAnimationType(type);

    let parentElement = element.parentElement;
    removeActiveChildren(parentElement);

    classList.add("active");
    updateAnimationElementsType(type);
  }

  const removeActiveChildren = (element) => {
    let activeElement = element.querySelector(".active");
    activeElement?.classList.remove("active");
  }

  const updateAnimationElementsType = (animationType) => {
    elements.forEach(element => {
      element.setAttribute("data-animation-type", animationType);
    });
  }

  const updateAnimationElementSpeed = (animationSpeed) => {
    elements.forEach(element => {
      element.setAttribute("data-animation-speed", animationSpeed);
    });
  }


  return (

    <>

      <div className="widget-wrapper">
        <div className="header">
          <span className="label">Animation Settings</span>
        </div>

        <div className="inner">
          <div className="layout">
            <div className="widget-wrapper">
              <div className="children">
                <div className="widget widget-label">
                  <label>Cycle mode</label>
                  <div className="widget togglebutton-widget horizontal-widget">


                    <div className="widget-wrapper">
                      <ul className="options">

                        <li className="option active" onClick={handleAnimationType} data-cid="c701" data-value="1">
                          <div className="option-row">
                            <a className="tooltip" data-tooltip="Back-Forward">
                              <i className="fast forward icon viewer-icon-cycle-no-repeat" />
                              <span className="option-row__label" />
                            </a>
                          </div>
                        </li>

                        <li className="option" onClick={handleAnimationType} data-cid="c702" data-value="0">
                          <div className="option-row">
                            <a className="tooltip" data-tooltip="Backward">
                              <i className="sync icon viewer-icon-cycle-repeat-one" />
                              <span className="option-row__label" />
                            </a>
                          </div>
                        </li>

                        <li className="option" onClick={handleAnimationType} data-cid="c703" data-value="none">
                          <div className="option-row">
                            <a className="tooltip" data-tooltip="Forward">
                              <i className="fast backward icon viewer-icon-cycle-repeat-all" />
                              <span className="option-row__label" />
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>


                <div className="widget widget-label">
                  <label >Playback speed</label>
                  <div className="widget togglebutton-widget horizontal-widget" id="AnimationsSpeedModeToggle">
                    <div className="widget-wrapper">
                      <ul className="options">

                        <li className="option" onClick={handleAnimationSpeed} data-value="0.1" title="x0.1">
                          <div className="option-row">
                            <a>
                              <span className="option-row__label">x0.1</span>
                            </a>
                          </div>
                        </li>
                        <li className="option" onClick={handleAnimationSpeed} data-value="0.5" title="x0.5">
                          <div className="option-row">
                            <a>
                              <span className="option-row__label">x0.5</span>
                            </a>
                          </div>
                        </li>

                        <li className="option active" onClick={handleAnimationSpeed} data-value="1" title="x1.0">
                          <div className="option-row">
                            <a><span className="option-row__label">x1.0</span></a>
                          </div>
                        </li>

                        <li className="option" onClick={handleAnimationSpeed} data-value="2" title="x2.0">
                          <div className="option-row">
                            <a>
                              <span className="option-row__label">x2.0</span>
                            </a>
                          </div>
                        </li>
                      </ul>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )

}

export default AnimationSettings;
